module.exports = __webpack_public_path__ + "img/science_leaders.f29bbb19.jpg";